<template>
  <div class="wrapper">
    <img v-if="downloadBanner != ''" :src="downloadBanner" class="backgroundImg">
    <img v-if="downloadBanner == ''" src="../assets/img/bg.png" class="backgroundImg">
    <!-- <table style="width: 100%">
      <tr>
        <td style="width: 20%"></td>
        <td style="width: 30%">
          <div class="img-box">
            <div id="downloadQrCode"></div>
            <p class="img-box-title">苹果 + 安卓端下载</p>
          </div>
        </td>
        <td style="width: 30%">
          <div class="img-box-second">
            <div id="downloadQrCodeSecond"></div>
            <p class="img-box-title">苹果TF版下载（防闪退）</p>
          </div>
        </td>
        <td style="width: 20%"></td>
      </tr>
    </table> -->
    <table style="width: 100%; margin-top: 300px; position: absolute; z-index: 1000;">
      <tr>
        <td style="width:25%">
          <div style="float: left; margin-left: 10%">
            <button class="buttonStyle" @click="showPopup('vueandrod')">
              <img src="../assets/img/Aandroid.png" style="width: 200px; height:80px" >
            </button>
          </div>
        </td>
        <td style="width: 25%">
          <div style="float: left;">
            <button class="buttonStyle" @click="showPopup('nativeapp_ios')">
              <img src="../assets/img/aAPLE.png" style="width: 200px; height:80px" >
            </button>
          </div>
        </td>
        <td style="width: 25%">
          <div style="float: left;">
            <button class="buttonStyle" @click="showPopup('testflight')">
               <img src="../assets/img/Aapple.png" style="width: 200px; height:80px" >
             </button>
          </div>
        </td>
        <td style="width: 25%"></td>
      </tr>
      <!-- =============================== second line ============================= -->
      <tr>
        <td style="width:25%">
          <div style="float: left; margin-left: 10%">
           <button class="buttonStyle" @click="showPopup('windows')">
              <img src="../assets/img/aWINDOW.png" style="width: 200px; height:80px" >
            </button>
          </div>
        </td>
        <td style="width: 25%">
          <div style="float: left;">
            <button class="buttonStyle" @click="showPopup('mac')">
              <img src="../assets/img/AMac.png" style="width: 200px; height:80px" >
            </button>
          </div>
        </td>
        <td style="width: 25%">
          
        </td>
      </tr>
      <!-- ================================ third line ================================ -->
      <tr>
        <td style="width:25%">
          <div style="float: left; margin-left: 10%">
            <button class="buttonStyle" @click="showPopup('hkandroid')">
              <img src="../assets/img/GAGNANZHOU.png" style="width: 200px; height:80px" >
            </button>
          </div>
        </td>
        <td style="width: 25%">
          <div style="float: left;">
            <button class="buttonStyle" @click="showPopup('hkapple')">
               <img src="../assets/img/GANG APPLE.png" style="width: 200px; height:80px" >
            </button>
          </div>
        </td>
        <td style="width: 25%">
          <div style="float: left;">
            <button class="buttonStyle" @click="showPopup('hkappletf')">
              <img src="../assets/img/GANG TF.png" style="width: 200px; height:80px" >
            </button>
          </div>
        </td>
      </tr>
    </table>
    <el-dialog id="dialogStyle" :visible.sync="qrPopup" width="450px" center>
      <div class="img-box">
        <div id="downloadQrCodeSecond"></div>
        <p class="img-box-title">{{ popupContent }}</p><br/>
        <div v-if="testflight_tf==true"><p>1.扫描二维码后点击“在App Srote中查看”，安装并打开TestFlight。
                <br/>2.再次扫描二维码，点大牛证券图标下“开始测试”-“接受”-“安装”按钮，即可使用。
                <br/></p><p style="color:red">说明：TF全称是testflight，是一种苹果官方的分发模式。</p></div>
        <div v-if="hkapple_tf==true"><p>1.扫描二维码后点击“在App Srote中查看”，安装并打开TestFlight。
                <br/>2.再次扫描二维码，点大牛港股图标下“开始测试”-“接受”-“安装”按钮，即可使用。   
                <br/></p><p style="color:red">说明：TF全称是testflight，是一种苹果官方的分发模式。</p></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  name: "download",
  data() {
    return {
      info: {
        qq: [],
        phone: [],
        codes: [],
      },
      appDownload: "",
      testFlightDownload: "",
      androidPro: "",
      appleFreeUpgrade: "",
      androidFreeUpgrade: "",
      nativeApp: "",
      qrPopup: false,
      popupContent: "",
      qrCode: null,
      pc_mac: "",
      pc_windows: "",
      hk_android: "",
      hk_apple: "",
      hk_apple_tf: "",
      downloadBanner: "",
      visiblepeizi: false,
      visiblehk: false,
      testflight_tf: false,
      hkapple_tf: false
    };
  },
  computed: {},
  methods: {
    showPopup(operate) {
      switch (operate) {
        case "testflight":
          this.qrPopup = true;
          this.popupContent = "苹果手机TF版(防封)";
          this.testflight_tf = true;
          this.hkapple_tf = false;
          setTimeout(() => {
            this.QrCode(this.testFlightDownload);
          }, 300);
          break;
        case "vueandrod":
          this.qrPopup = true;
          this.popupContent = "安卓专业版";
          this.testflight_tf = false;
          this.hkapple_tf = false;
          setTimeout(() => {
            this.QrCode(this.androidPro);
          }, 300);
          break;
        case "applefree":
          this.qrPopup = true;
          this.popupContent = "苹果免升级版";
          this.testflight_tf = false;
          this.hkapple_tf = false;
          setTimeout(() => {
            this.QrCode(this.appleFreeUpgrade);
          }, 300);
          break;
        case "androidfree":
          this.qrPopup = true;
          this.popupContent = "安卓免升级版";
          this.testflight_tf = false;
          this.hkapple_tf = false;
          setTimeout(() => {
            this.QrCode(this.androidFreeUpgrade);
          }, 300);
          break;
        case "nativeapp_android":
          this.qrPopup = true;
          this.popupContent = "安卓经典版";
          this.testflight_tf = false;
          this.hkapple_tf = false;
          setTimeout(() => {
            this.QrCode(this.nativeApp);
          }, 300);
          break;
        case "nativeapp_ios":
          this.qrPopup = true;
          this.popupContent = "苹果经典版";
          this.testflight_tf = false;
          this.hkapple_tf = false;
          setTimeout(() => {
            this.QrCode(this.nativeApp);
          }, 300);
          break;
        case "hkandroid":
          this.qrPopup = true;
          this.popupContent = "大牛港股安卓版";
          this.testflight_tf = false;
          this.hkapple_tf = false;
          setTimeout(() => {
            this.QrCode(this.hk_android);
          }, 300);
          break;
        case "hkapple":
          this.qrPopup = true;
          this.popupContent = "大牛港股苹果版";
          this.testflight_tf = false;
          this.hkapple_tf = false;
          setTimeout(() => {
            this.QrCode(this.hk_apple);
          }, 300);
          break;
        case "hkappletf":
          this.qrPopup = true;
          this.popupContent = "苹果手机TF版(防封)";
          this.testflight_tf = false;
          this.hkapple_tf = true;
          setTimeout(() => {
            this.QrCode(this.hk_apple_tf);
          }, 300);
          break;
        case "mac":
          this.qrPopup = false;
          this.popupContent = "MAC桌面端";
          this.testflight_tf = false;
          this.hkapple_tf = false;
          window.open(this.pc_mac)
          break;
        case "windows":
          this.qrPopup = false;
          this.popupContent = "Windows桌面端";
          this.testflight_tf = false;
          this.hkapple_tf = false;
          window.open(this.pc_windows)
          break;

        default:
          break;
      }
    },
    QrCode(url) {
      if (this.qrCode) {
        this.qrCode.makeCode(url);
      } else {
        this.qrCode = new QRCode("downloadQrCodeSecond", {
          width: 345,
          height: 345,
          text: url, // 二维码地址
        });
      }
    },
    // QrCodeSecond(url) {
    //   new QRCode("downloadQrCodeSecond", {
    //     width: 345,
    //     height: 345,
    //     text: url,
    //   });
    // },
    getInfoData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "web_common",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.info = data;
            // that.QrCode(that.info.codes[0].code);
            that.appDownload = that.info.codes[0].code;
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
    getQRLink() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            action: "download_link",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            // that.QrCodeSecond(res.data.data);
            that.testFlightDownload = res.data.data.iOS_testflight;
            that.androidPro = res.data.data.android_pro;
            that.appleFreeUpgrade = res.data.data.apple_free_upgrade;
            that.androidFreeUpgrade = res.data.data.android_free_upgrade;
            that.nativeApp = res.data.data.app_app;
            that.pc_mac = res.data.data.pc_mac;
            that.pc_windows = res.data.data.pc_windows;
            that.hk_android = res.data.data.hk_android;
            that.hk_apple = res.data.data.hk_apple;
            that.hk_apple_tf = res.data.data.hk_apple_tf;
            that.downloadBanner = res.data.data.downgrade_image;
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
  },
  mounted: function () {
    this.getInfoData();
    // this.QrCodeSecond();
    this.getQRLink();
  },
};
</script>

<style scoped>
.wrapper {
  /* background: url(../assets/img/bg.png) no-repeat center; */
  /* background-size: cover;
  background-position: 5% 70%; */
  min-width: 1000px;
  height: 720px;
  overflow: hidden;
  position: relative;
}

.backgroundImg{
  pointer-events: none;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
}
.img-box {
  width: 100%;
  opacity: 0.85;
  background: white;
  /* margin: 200px auto; */
  /* padding-top: 20px; */
}
.img-box img {
  width: 100%;
}
.img-box-title {
  text-align: center;
  font-size: 25px;
  padding: 28px 0px 0px 0px;
  color: red;
}

/*.img-box-second {
  width: 400px;
  opacity: 0.85;
  background: white;
  margin: 200px auto;
  padding-top: 20px;
}
.img-box-titl-second {
  text-align: center;
  font-size: 25px;
  padding: 10px 0;
} */

.tm-ic {
  display: inline-block;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  width: 40px;
  height: 40px;
}

.ffic-android {
  background-image: url(../assets/img/icons/ffic-android.png);
}

.ffic-iphone {
  background-image: url(../assets/img/icons/ffic-iphone.png);
}

.windows {
  background-image: url(../assets/img/icons/windows.png);
}

.mac {
  background-image: url(../assets/img/icons/mac.png);
}

.buttonStyle {
  display: flex;
  margin: 20px 0px;
  background-color: transparent;
  cursor: pointer;
}

</style>

<style>
#dialogStyle .el-dialog__body {
  padding: 25px 25px 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/download.vue